// type : [ 'processing','prepayment']

import { getDirectusInstance } from './auth.js';

export function getCRMURL() {

        return {
                t: localStorage.getItem("crm_auth_token"),
                u: process.env.CRM_URL
        };
}
async function getCRM(path, token, signal = null, responseType = 'json') {
        const fetchOptions = {
                method: "GET",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        };
        
        if (signal) {
                fetchOptions.signal = signal;
        }
        
        let result = await fetch(`${process.env.CRM_URL}${path}`, fetchOptions);
        if (responseType === 'blob') {
                return result;
        }
        return await result.json();
}

async function deleteCRM(path, token) {
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "DELETE",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });

        return await result.json();
}

async function updateCRM(path, token) {
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "PATCH",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        return await result.json();
}

export async function getGreeners(path, token, responseType = 'json') {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "GET",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        if (responseType === 'blob') {
                return result;
        }
        return await result.json();
}

export async function postGreeners(path, token, body, isFormData = false) {
        const headers = {
                "Authorization": `Bearer ${token}`,
        };
        if (!isFormData) {
                headers["Content-Type"] = "application/json";
        }
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "POST",
                headers,
                body: isFormData ? body : JSON.stringify(body)
        });
        return await result.json();
}

export async function patchGreeners(path, token, body, isFormData = false) {
        const headers = {
                "Authorization": `Bearer ${token}`,
        };
        if (!isFormData) {
                headers["Content-Type"] = "application/json";
        }
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "PATCH",
                headers,
                body: isFormData ? body : JSON.stringify(body)
        });
        return await result.json();
}

export async function putGreeners(path, token, body, isFormData = false) {
        const headers = {
                "Authorization": `Bearer ${token}`,
        };
        if (!isFormData) {
                headers["Content-Type"] = "application/json";
        }
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "PUT",
                headers,
                body: isFormData ? body : JSON.stringify(body)
        });
        return await result.json();
}

export async function deleteGreeners(path, token) {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "DELETE",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        const text = await result.text();
        return text ? JSON.parse(text) : {};
}

// ── Pricing engine (product-price-recommendation extension on Greeners) ──
// Start a recompute of all price recommendations (fire-and-forget; returns { started, running }).
export async function runPriceRecommendation(token = localStorage.getItem('greeners_auth_token')) {
        return await postGreeners('price-recommendation/run', token, {});
}
// Recompute ONLY this pharmacy's prices from the existing sale_logs/settings/scoring (no backfill).
export async function recomputePharmacyPrices(token = localStorage.getItem('greeners_auth_token')) {
        return await postGreeners('price-recommendation/recompute', token, {});
}
// Search ALL products (Redis catalog, new + existing) by name for the dashboard dropdown.
export async function searchPricingProducts(q, token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners(`price-recommendation/search?q=${encodeURIComponent(q || '')}`, token);
}
// Live, UNSAVED price preview: run the engine for one product with edited overrides (thc, EK, MHD).
export async function previewPrice(body, token = localStorage.getItem('greeners_auth_token')) {
        return await postGreeners('price-recommendation/preview', token, body);
}
// Poll whether a recompute is currently in progress ({ running: true|false }).
export async function getPriceRecommendationStatus(token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners('price-recommendation/status', token);
}

export async function postCRM(path, token, body, isFormData = false) {
        let headers = {
                "Authorization": `Bearer ${token}`,
        };
        if (!isFormData) {
                headers["Content-Type"] = "application/json";
        }
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "POST",
                headers,
                body: isFormData ? body : JSON.stringify(body)
        });
        return await result.json();
}


export async function getOrders(query, type, token = localStorage.getItem("crm_auth_token")) {
        try {

                const args = {
                        dest: 'crm',
                        type: 'orders',
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['date_created'],);

                return await getCRM(`crm/orders/${type}?${queryString}`, token);

        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getImportTask(query, token = localStorage.getItem("crm_auth_token")) {
        try {

                const args = {
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['date_created'],);

                return await getCRM(`import/?${queryString}`, token);

        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getLogsByTaskId(taskId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`import/logs/${taskId}/`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCsvSchemas(pharmacyId, token = localStorage.getItem("crm_auth_token")) {
    try {
        const directus = getDirectusInstance();
        const schemas = await directus.items('csv_schemas').readByQuery({
            filter: {
                user_created: { _eq: pharmacyId }
            },
            fields: ['id', 'name', 'schema_json'],
            sort: ['name']
        });
        return schemas.data || [];
    } catch (e) {
        console.log('getCsvSchemas error:', e);
        return [];
    }
}


export async function getOrderItems(id, token = localStorage.getItem("crm_auth_token")) {
        if (!id) return [];
        try {
                return await getCRM(`order-items/order/${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getDoneOrdersCount(ordersId = [], user_created, orderSource = "BW",  token = localStorage.getItem("crm_auth_token")) {
        if (!ordersId?.length) return [];
        try {
                return await postCRM(`crm/orders/count`, token, {
                        filter: JSON.stringify({
                                _and: [
                                        { status: { _nin: ["sent", "cancellation"] } },
                                        { external_order_id: { _nin: ordersId } },
                                        { user_created: user_created },
                                        { source: orderSource }
                                ]
                        }),
                });
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCachedProductInventory(query, endpoint = 'all', token = localStorage.getItem("crm_auth_token")) {
        const args = {
                type: query.type,
                limit: query.limit,
                page: null,
                filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
        };

        args.dest = 'crm';

        if (args.limit === -1) {
                delete args['page'];
        }

        let queryString = new URLSearchParams(args).toString();
        queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['name'],);

        return await getCRM(`greeners-cache/read/${endpoint}?${queryString}`, token);

}

export async function getProductInventory(query, endpoint = 'list', token = localStorage.getItem('greeners_auth_token')) {

        const args = {
                type: query.type,
                limit: query.limit,
                page: query.page,
                filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
        };
        args.dest = query?.dest ? query?.dest : 'crm';

        if (query.searchField != null && `${query.searchField}`.trim() !== '') {
                args.searchField = query.searchField;
        }

        if (args.limit === -1) {
                delete args['page'];
        }

        let queryString = new URLSearchParams(args).toString();
        queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['name'],);

        return await getGreeners(`productinventory/${endpoint}?${queryString}`, token);
}


export async function getManualInventoryChanges(query = {}, token = localStorage.getItem('greeners_auth_token')) {
        const args = {
                page: query.page || 1,
                limit: query.limit != null ? query.limit : 10,
        };

        if (query.search != null && `${query.search}`.trim() !== '') {
                args.search = `${query.search}`.trim();
        }

        if (query.reasons?.length) {
                args.reasons = JSON.stringify(query.reasons);
        }

        const queryString = new URLSearchParams(args).toString();

        return await getGreeners(`productinventory/manual-inventory-changes?${queryString}`, token);
}


export async function getStockAvailabilityReport(query = {}, token = localStorage.getItem('greeners_auth_token')) {
        const args = {
                page: query.page || 1,
                limit: query.limit || 200,
        };

        const queryString = new URLSearchParams(args).toString();

        return await getGreeners(`productinventory/stock-availability-report?${queryString}`, token);
}


export async function getProductInventoryV2(query, token = localStorage.getItem('greeners_auth_token')) {
        const args = {
                type: query.type,
                limit: query.limit,
                page: query.page,
                filter: query.filter ? JSON.stringify(query.filter) : JSON.stringify({}),
                dest: query.dest ? query.dest : 'crm',
                isStockManagementLogs: query.isStockManagementLogs || false,
        };

        if (query.searchField != null && `${query.searchField}`.trim() !== '') {
                args.searchField = query.searchField;
        }
        // Cansativa availability is its own key: it means wholesaler + stock + PZN,
        // which is not the same thing as the Verfügbarkeit filter.
        if (query.cansativa === 'available' || query.cansativa === 'unavailable') {
                args.cansativa = query.cansativa;
        }
        // Only pharmacies allowed to order get the wholesaler lookup at all.
        if (query.withCansativa) {
                args.withCansativa = true;
        }
        let queryString = new URLSearchParams(args).toString();
        if (query?.sortField && query?.sortOrder)
                queryString += `&sortField=${query.sortField}&sortOrder=${query.sortOrder}`;
        if (query.productsWithInventoryOnly) {
                queryString += `&productsWithInventoryOnly=${query.productsWithInventoryOnly}`;
        }
        if (query.isStockManagementLogs)
                queryString += `&isStockManagementLogs=${query.isStockManagementLogs}`;


        return await getGreeners(`productinventory/list/v2?${queryString}`, token);
}

export async function getProductListV2(query, token = localStorage.getItem('greeners_auth_token')) {
        const args = {
                limit: query.limit,
                page: query.page,
                filter: query.filter ? JSON.stringify(query.filter) : JSON.stringify({}),
                searchField: query.searchField || '',
        };

        let queryString = new URLSearchParams(args).toString();
        if (query?.sortField && query?.sortOrder) {
                queryString += `&sortField=${query.sortField}&sortOrder=${query.sortOrder}`;
        }

        if (query.productsWithInventoryOnly) {
                queryString += `&productsWithInventoryOnly=${query.productsWithInventoryOnly}`;
        }

        return await getGreeners(`product/list/v2?${queryString}`, token);
}

export async function updateInventoryAndStockLogs(body, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await postGreeners('productinventory/update', token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getStockMgmtReasons(token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners('productinventory/list/stock-management-reasons', token);
}

export async function getProductMovements({ dateFrom, dateTo, orderIds = [] }, token = localStorage.getItem('greeners_auth_token')) {
        const params = new URLSearchParams({
                dateFrom,
                dateTo,
                orderIds: JSON.stringify(orderIds),
        });
        return await getGreeners(`productinventory/product-movements?${params.toString()}`, token);
}
export async function getFile(id, token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners(`assets/${id}`, token, 'blob');
}
export async function getProductsByIds(ids, token = localStorage.getItem('greeners_auth_token')) {
        if(!ids || !ids.length) return [];

        let queryString = `ids=${JSON.stringify(ids)}`;
        return await getGreeners(`productinventory/for-product-ids?${queryString}`, token);
}

export async function getProductItem(type, id, token = localStorage.getItem('greeners_auth_token')) {
        let productResult = await getGreeners(`items/${type}/${id}`, token);

        return productResult;
}

function arrayToUrlParameter(key, array) {
        let str = '';
        for (let i = 0; i <= array.length - 1; i++) {
                str += `&${key}[]=${array[i]}`
        }
        return str;
}

export async function getOrderComments(id, token) {
        try {
                return await getCRM(`crm/orders/comments?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

/**
 * This function retrieves the activity log for a specific order using a provided order ID.
 * @param id - The ID of the order for which you want to retrieve the activity log.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API URL.
 * @returns a Promise that resolves to the JSON response from a GET request to the Directus API
 * endpoint for retrieving the activity log of a specific order. The response contains information
 * about the actions taken on the order, such as updates, comments, and status changes. If an error
 * occurs during the request, the function logs the error to the console.
 */
export async function getOrdersActivitylog(id, token) {
        try {
                return await getCRM(`crm/orders/activity?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getOrdersActivitylogV2(id, token) {
  try {
    return await getCRM(`crm/orders/activity/v2?id=${id}`, token);
  } catch (e) {
    console.log(e);
    return [];
  }
}

/**
 * This function retrieves the payment verification state and returns it as a JSON
 * object.
 * @param token - The access token used to authenticate the API request.
 * @returns This function is returning the result of a GET request to the
 * `crm/payment_verification_state` endpoint with an access token passed as a query parameter. The
 * response is expected to be in JSON format, and the function is returning the parsed JSON data. If
 * there is an error, it will be caught and logged to the console.
 */
export async function getPaymentVerificationState(token) {
        try {
                return await getCRM(`crm/payment_verification_state`, token);
        } catch (e) {
                console.log(e);
        }
}

/**
 * This is an asynchronous function that retrieves a single order from a CRM system using an order ID
 * and access token.
 * @param id - The ID of the order that you want to retrieve from the CRM system.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API endpoint URL.
 * @returns the result of the API call to retrieve a single order with the specified orderId and token.
 * The result is expected to be in JSON format. If there is an error, an empty array is returned.
 */
export async function getOrder(id, token) {
        try {
                return await getCRM(`crm/orders/single?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCustomerData(id, token) {
        try {
                return await getCRM(`crm/customer_data/single?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCurrentVersion() {
        try {
                const result = await fetch(`${process.env.CRM_URL}crm/get-current-version`, {
                        method: "GET",
                        headers: {
                                "Content-Type": "application/json",
                        },
                });
                const response = await result.json();
                return response?.version || null;
        } catch (e) {
                console.log(e);
                return null;
        }
}
/**
 * This function retrieves autosuggested customers based on a query.
 * @param query - The `query` parameter is an object that contains a `filter` property. The `filter`
 * property is an object that specifies the filter criteria for the autosuggest query.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API URL.
 * @returns the result of a fetch request to a Directus API endpoint for autosuggesting customers based
 * on a given query and access token. The result is expected to be in JSON format. If there is an
 * error, an empty array is returned.
 */
export async function getAutosuggestedCustomers(query, token) {
        try {
                const queryString = new URLSearchParams({
                        filter: JSON.stringify(query.filter),
                }).toString();

                return await getCRM(`crm/customer/autosuggest?${queryString}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function updatePrescriptionOfInventories(body, token) {
        try {
                return await postGreeners(`productinventory/list/inventory/updatePrescriptionProviders`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

const PHARMACY_PROVIDER_SURCHARGE = 'pharmacy_provider_surcharge';

export async function getProviderSurchargeConfig(pharmacyId, token = localStorage.getItem('greeners_auth_token')) {
        try {
                const filter = JSON.stringify({ pharmacy_id: { _eq: pharmacyId } });
                const queryString = new URLSearchParams({
                        filter,
                        fields: 'id,provider_id,surcharge_value,surcharge_unit',
                        limit: -1
                }).toString();
                const result = await getGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}?${queryString}`, token);
                const data = result?.data || [];
                const config = {};
                data.forEach((row) => {
                        const providerId = typeof row.provider_id === 'object' ? row.provider_id?.id : row.provider_id;
                        if (providerId) {
                                config[providerId] = {
                                        id: row.id,
                                        value: row.surcharge_value,
                                        unit: row.surcharge_unit || '%'
                                };
                        }
                });
                return config;
        } catch (e) {
                console.error('Error fetching provider surcharge config:', e);
                return {};
        }
}

export async function createProviderSurcharge(payload, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await postGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}`, token, payload);
        } catch (e) {
                console.error('Error creating provider surcharge:', e);
                throw e;
        }
}

export async function updateProviderSurcharge(id, payload, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await patchGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}/${id}`, token, payload);
        } catch (e) {
                console.error('Error updating provider surcharge:', e);
                throw e;
        }
}

export async function deleteProviderSurcharge(id, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await deleteGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}/${id}`, token);
        } catch (e) {
                console.error('Error deleting provider surcharge:', e);
                throw e;
        }
}

export async function getExistingProviderSurchargeId(pharmacyId, providerId, token = localStorage.getItem('greeners_auth_token')) {
        try {
                const filter = JSON.stringify({
                        _and: [
                                { pharmacy_id: { _eq: pharmacyId } },
                                { provider_id: { _eq: providerId } }
                        ]
                });
                const queryString = new URLSearchParams({
                        filter,
                        fields: 'id',
                        limit: 1
                }).toString();
                const result = await getGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}?${queryString}`, token);
                return result?.data?.[0]?.id;

        } catch (e) {
                console.error('Error fetching existing provider surcharge:', e);
                return null;
        }
}

export async function fetchOrderSource(token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`crm/orders/source`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function fetchCustomerGroup(token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`crm/orders/customer/groups`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function abortTask(taskId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await updateCRM(`import/${taskId}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function uploadCSVFile(data, token = localStorage.getItem("crm_auth_token")) {
        const formData = new FormData();
        formData.append("file", data?.file);
        formData.append("metadata", JSON.stringify(data?.metadata));

        try {
                return await postCRM("import", token, formData, true);
        } catch (error) {
                console.error("File upload failed:", error);
                throw error;
        }
}

/* ---- V2 CardFlo integration (pharmacies with `cardflo_integrations_v2`) ---- */

export async function cancelPaymentLinkV2(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/v2/cancel-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

/** V2 answers about the deposit for an order, so this takes an orderId. */
export async function getPaymentStatusV2(orderId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`cardflo/v2/payment-status/${orderId}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

/** Resends the CardFlo V2 payment link mail for an order that already has a link. */
export async function sendPaymentLinkEmailV2(orderId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`notifications/cardflo/payment-link-email/${orderId}`, token, {});
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function refundOrVoidV2(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/v2/refund`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function cancelPaymentLink(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/cancel-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getPaymentLinkStatus(paymentLinkId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`cardflo/payment-link-status/${paymentLinkId}`, token);
        } catch (e) {
                console.log(e);
                return null;
        }
}

export async function refundOrVoid(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/refund`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
/** V2 CardFlo integration — only for pharmacies with the `cardflo_v2` operation. */
export async function sendPaymentLinkV2(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/v2/generate-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function sendPaymentLink(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/generate-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
export async function bulkOrderUpdate(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/bulk-update`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

/** Bulk mark orders paid with today’s date (async task; poll with getBulkOrderStatus + operationType=mark_paid). */
export async function bulkMarkPaidToday(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/bulk-mark-paid`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function getBulkOrderStatus(taskId, token = localStorage.getItem('crm_auth_token'), query = {}) {
        try {
          const queryString = new URLSearchParams(query)?.toString() || '';
          return await getCRM(`order/task/${taskId}?${queryString}`, token);
        } catch (e) {
          console.log(e);
          return [];
        }
}
export async function createProtocolItems(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/protocol-items`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export function openBulkProtocolPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}order/protocol-items/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export function openBulkDeliveryNotesPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}order/delivery-notes/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export function openBulkUrbifyLabelsPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}urbify/labels/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export async function deleteUrbifyLabelsPdf(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await deleteCRM(`urbify/labels/delete-file/${taskId}`, token);
        } catch (e) {
          console.log(e);
          return null;
        }
}

/**
 * Single-order: generate Urbify label PDF on server, then open download URL.
 */
export async function createAndOpenUrbifyLabelPdf(body = {}, token = localStorage.getItem('crm_auth_token')) {
        const response = await fetch(`${process.env.CRM_URL}urbify/label-pdf`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
        });
        if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err?.errors?.[0]?.message || err?.message || 'Urbify PDF Fehler');
        }
        const data = await response.json();
        if (!data?.downloadId) {
                throw new Error('Keine Download-ID erhalten');
        }
        const url = `${process.env.CRM_URL}urbify/label-pdf/download/${data.downloadId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return { ...data, opened };
}

export function openBulkDhlLabelsPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}order/dhl-labels/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export async function deleteDhlLabelsPdf(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await deleteCRM(`order/dhl-labels/delete-file/${taskId}`, token);
        } catch (e) {
          console.log(e);
          return null;
        }
}

/**
 * Single-order DHL Parcel or Express: store base64 label PDF(s) on server, open named URL.
 * @param {{ labels: string[], express?: boolean }} body
 */
export async function createAndOpenDhlLabelPdf(body = {}, token = localStorage.getItem('crm_auth_token')) {
        const response = await fetch(`${process.env.CRM_URL}order/dhl-labels/store-pdf`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
        });
        if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err?.errors?.[0]?.message || err?.message || 'DHL PDF Fehler');
        }
        const data = await response.json();
        if (!data?.downloadId) {
                throw new Error('Keine Download-ID erhalten');
        }
        const url = `${process.env.CRM_URL}order/dhl-labels/store-pdf/download/${data.downloadId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return { ...data, opened };
}

export function openBulkProductLabelsPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}order/product-labels/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export async function deleteProductLabelsPdf(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await deleteCRM(`order/product-labels/delete-file/${taskId}`, token);
        } catch (e) {
          console.log(e);
          return null;
        }
}

/**
 * Single-order product labels: generate PDF on server from flat label objects, open named URL.
 * @param {{ labels: object[] }} body
 */
export async function createAndOpenProductLabelsPdf(body = {}, token = localStorage.getItem('crm_auth_token')) {
        const response = await fetch(`${process.env.CRM_URL}order/product-labels/store-pdf`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
        });
        if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err?.errors?.[0]?.message || err?.message || 'Produktetiketten PDF Fehler');
        }
        const data = await response.json();
        if (!data?.downloadId) {
                throw new Error('Keine Download-ID erhalten');
        }
        const url = `${process.env.CRM_URL}order/product-labels/store-pdf/download/${data.downloadId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return { ...data, opened };
}

export async function deleteDeliveryNotesPdf(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await deleteCRM(`order/delivery-notes/delete-file/${taskId}`, token);
        } catch (e) {
          console.log(e);
          return null;
        }
}

export async function deleteProtocolPdf(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await deleteCRM(`order/protocol-items/delete-file/${taskId}`, token);
        } catch (e) {
          console.log(e);
          return null;
        }
}

/** Single-order: backend loads protocol from DB, streams PDF with custom filename */
export function getSingleOrderProtocolPdfUrl(orderId, query = {}) {
        const params = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                        params.set(key, value);
                }
        });
        const qs = params.toString();
        return `${process.env.CRM_URL}pdf/protocol/order/${orderId}${qs ? `?${qs}` : ''}`;
}

/**
 * Open a PDF fetch Response in a new tab.
 * Uses Content-Disposition filename when present (DA-3-6336 prefixes).
 */
export async function openPdfResponseInNewTab(response, fallbackFilename = 'document.pdf') {
        const blob = await response.blob();
        if (!blob || blob.size === 0) {
                throw new Error('Keine PDF erhalten.');
        }

        let filename = fallbackFilename;
        try {
                const disposition = response.headers?.get?.('Content-Disposition');
                if (disposition) {
                        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (match?.[1]) {
                                filename = match[1].replace(/['"]/g, '').trim();
                        }
                }
        } catch (_) {
                // keep fallbackFilename
        }

        const pdfBlob =
                blob.type === 'application/pdf'
                        ? blob
                        : new Blob([blob], { type: 'application/pdf' });
        // File() preserves download name better than a raw blob URL
        const file = new File([pdfBlob], filename, { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(file);
        const opened = window.open(blobUrl, '_blank');
        if (!opened) {
                URL.revokeObjectURL(blobUrl);
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
        return { opened, filename };
}

/**
 * Open single-order protocol PDF (DB fetch on server).
 * Fetches with Bearer auth (no token in URL), then opens a blob tab.
 */
export async function openSingleOrderProtocolPdf(orderId, query = {}, token = localStorage.getItem('crm_auth_token')) {
        const url = getSingleOrderProtocolPdfUrl(orderId, {
                ...query,
                qrBaseUrl: query.qrBaseUrl || window.location.origin,
        });
        const response = await fetch(url, {
                headers: {
                        Authorization: `Bearer ${token}`,
                },
        });
        if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(
                        err?.errors?.[0]?.message || err?.message || 'Fehler beim Generieren des Abfüllprotokolls'
                );
        }
        return openPdfResponseInNewTab(response, query.filename || 'abfuellprotokolle.pdf');
}

/** Single-order Laufzettel: backend loads order, streams PDF with custom filename */
export function getSingleOrderDeliveryNotePdfUrl(orderId, query = {}) {
        const params = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                        params.set(key, value);
                }
        });
        const qs = params.toString();
        return `${process.env.CRM_URL}pdf/delivery-note/order/${orderId}${qs ? `?${qs}` : ''}`;
}

/**
 * Open single-order delivery note PDF (Laufzettel).
 * Fetches with Bearer auth (no token in URL), then opens a blob tab.
 */
export async function openSingleOrderDeliveryNotePdf(orderId, query = {}, token = localStorage.getItem('crm_auth_token')) {
        const url = getSingleOrderDeliveryNotePdfUrl(orderId, {
                ...query,
                qrBaseUrl: query.qrBaseUrl || window.location.origin,
        });
        const response = await fetch(url, {
                headers: {
                        Authorization: `Bearer ${token}`,
                },
        });
        if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(
                        err?.errors?.[0]?.message || err?.message || 'Fehler beim Generieren des Laufzettels'
                );
        }
        return openPdfResponseInNewTab(response, query.filename || 'laufzettel.pdf');
}

/**
 * Modal create button: save protocol (body) + generate PDF on server.
 * POST /pdf/protocol/order/:orderId
 */
export async function createOrderProtocolPdf(orderId, body = {}, token = localStorage.getItem('crm_auth_token')) {
        const response = await fetch(`${process.env.CRM_URL}pdf/protocol/order/${orderId}`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
        });
        return response;
}

export async function createDeliveryNotes(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/delivery-notes`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createAttachments(body, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await postCRM(`order/attachments`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
export async function downloadAttachments(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await getCRM(`order/attachments/download/${taskId}`, token, null, 'blob');
        } catch (e) {
                console.log(e);
                return null;
        }
}

export function openBulkAttachmentsPdf(taskId) {
        if (!taskId) {
                throw new Error('Task ID is required');
        }
        const url = `${process.env.CRM_URL}order/attachments/download/${taskId}`;
        const opened = window.open(url, '_blank');
        if (!opened) {
                throw new Error('Pop-up blockiert. Bitte erlauben Sie Pop-ups für diesen Download.');
        }
        return opened;
}

export async function deleteAttachments(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await deleteCRM(`order/attachments/delete-file/${taskId}`, token);
        } catch (e) {
                console.log(e);
                return null;
        }
}
export async function createBulkDhlLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/dhl-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkUrbifyLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`urbify/bulk-shipment-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkProductLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/product-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkInvoices(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`cardflo/generate-bulk-invoices`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createOrder2_0(orderData, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/create`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(orderData)
                });
                
                if (!response.ok) {
                        // The backend sends the user-facing message directly
                        // (German for inventory failures, real message for
                        // everything else) — surface it as-is.
                        let body = null;
                        try {
                                body = await response.json();
                        } catch (_) {
                                // response body was not JSON
                        }
                        const serverError = body?.errors?.[0];
                        const message =
                                serverError?.message ||
                                body?.message ||
                                `HTTP error! status: ${response.status}`;
                        const err = new Error(message);
                        err.status = response.status;
                        err.code = serverError?.extensions?.code;
                        throw err;
                }

                return await response.json();
        } catch (e) {
                console.error('Error creating order:', e);
                throw e;
        }
}

export async function updateOrder2_0(orderId, orderData, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/update-order/${orderId}`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(orderData)
                });
                
                if (!response.ok) {
                        let body = null;
                        try {
                                body = await response.json();
                        } catch (_) {
                                // response body was not JSON
                        }

                        const serverError = body?.errors?.[0];
                        const code = serverError?.extensions?.code;

                        // The backend sends the user-facing message directly
                        // (German for inventory failures, real message for
                        // everything else) — surface it as-is.
                        const message =
                                serverError?.message ||
                                body?.message ||
                                `HTTP error! status: ${response.status}`;

                        const err = new Error(message);
                        err.status = response.status;
                        err.code = code;
                        throw err;
                }
                return await response.json();
        } catch (e) {
                console.error('Error updating order:', e);
                throw e;
        }
}

export async function getOrderDetails(orderId, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/${orderId}`, {
                        method: 'GET',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                }
        });

        if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
        } catch (e) {
                console.error('Error getting order details:', e);
                throw e;
        }
}

export async function getReservedOrdersV2(query, signal = null, token = localStorage.getItem("crm_auth_token")) {
        try {
                const args = {
                        dest: 'crm',
                        type: 'orders',
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['-date_created']);

                return await getCRM(`order/orderlist/getReservedOrdersV2?${queryString}`, token, signal);

        } catch (e) {
                if (e.name === 'AbortError') {
                        throw e;
                }
                console.log(e);
                return [];
        }
}

export async function getReservedOrdersCountV2(query, signal = null, token = localStorage.getItem("crm_auth_token")) {
        try {
                const args = {
                        dest: 'crm',
                        type: 'orders',
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                const queryString = new URLSearchParams(args).toString();

                return await getCRM(`order/orderlist/getReservedOrdersCountV2?${queryString}`, token, signal);

        } catch (e) {
                if (e.name === 'AbortError') {
                        throw e;
                }
                console.log(e);
                return null;
        }
}

export async function createInvoiceWithEmail(order, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/create-invoice-with-email`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify(order)
                });
                return await response.json();
        } catch (e) {
                console.error('Error creating invoice with email:', e);
                throw e;
        }
}


async function fastbillRequest(path, body = {}, token = localStorage.getItem('crm_auth_token')) {
        const response = await fetch(`${process.env.CRM_URL}order-items/fastbill/${path}`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(body)
        });

        const parsed = await response.json();

        if (!parsed?.state) {
                throw new Error(parsed?.message || 'FastBill request failed');
        }

        return parsed.data;
}

export const fastbillSearchInvoices = (limit = 100) => fastbillRequest('invoices/search', { limit });
export const fastbillGetInvoice = (filter) => fastbillRequest('invoices/get', filter);
export const fastbillCreateInvoice = (invoice) => fastbillRequest('invoices/create', { invoice });
export const fastbillCompleteInvoice = (invoiceId) => fastbillRequest('invoices/complete', { invoiceId });
export const fastbillSetInvoicePaid = (invoiceId, paidDate) => fastbillRequest('invoices/set-paid', { invoiceId, paidDate });
export const fastbillCancelInvoice = (invoiceId) => fastbillRequest('invoices/cancel', { invoiceId });
export const fastbillSendInvoiceEmail = (invoiceId, email) => fastbillRequest('invoices/send-email', { invoiceId, email });
export const fastbillSearchCustomer = (email) => fastbillRequest('customers/search', { email });
export const fastbillCreateCustomer = (customer) => fastbillRequest('customers/create', { customer });
export const fastbillUpdateCustomer = (customer) => fastbillRequest('customers/update', { customer });

/** Whether the pharmacy has FastBill configured -- no credentials are returned. */
export async function fastbillStatus(token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/fastbill/status`, {
                        method: 'GET',
                        headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                        }
                });
                const parsed = await response.json();
                return parsed?.data?.enabled === true;
        } catch (e) {
                console.error('Error checking fastbill status:', e);
                return false;
        }
}

export async function syncFastbillInvoices(token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/sync-fastbill-invoices`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                        }
                });
                return await response.json();
        } catch (e) {
                console.error('Error syncing fastbill invoices:', e);
                throw e;
        }
}

export async function getSyncFastbillInvoicesStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/sync-fastbill-invoices/status/${taskId}`, {
                        headers: {
                          Authorization: `Bearer ${token}`
                        }
                      });
                  
                return await response.json();   
        } catch (error) {
                console.error('Error getting sync fastbill invoices status:', error);
                throw error;
        }
}

export async function processBankTransfers(file, token = localStorage.getItem('crm_auth_token')) {
  try {
    const formData = new FormData();
    formData.append('csv', file);

    const response = await fetch(`${process.env.CRM_URL}order/process-bank-transfers`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    return await response.json();
  } catch (e) {
    console.error('Error processing bank transfers:', e);
    throw e;
  }
}

export async function getBankTransferTaskStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
  try {
    const response = await fetch(`${process.env.CRM_URL}order/bank-transfer-task/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return await response.json();
  } catch (e) {
    console.error('Error getting bank transfer task status:', e);
    throw e;
  }
}

export async function downloadProcessedCSV(filename, token = localStorage.getItem('crm_auth_token')) {
  try {
    const response = await fetch(`${process.env.CRM_URL}order/download-processed-csv/${filename}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  } catch (e) {
    console.error('Error downloading processed CSV:', e);
    throw e;
  }
}

export async function getDeliveryDetails(orderId, queryParams = {}) {
  try {
    const searchParams = new URLSearchParams(queryParams).toString()
    const url = `${process.env.CRM_URL}notifications/delivery/select/${orderId}${searchParams ? `?${searchParams}` : ''}`
    const response = await fetch(url);

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        ok: false,
        data: null,
        error: data?.message || "Unknown error"
      };
    }

    return {
      ok: true,
      data
    };
  } catch (e) {
    console.error("Error getting delivery details:", e);
    return {
      ok: false,
      error: e ||  "Network error"
    };
  }
}

export async function updateDeliveryMethod(orderId, deliveryDetails) {

  try {
    const response = await fetch(`${process.env.CRM_URL}notifications/delivery/update/${orderId}`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body : JSON.stringify(deliveryDetails)
    });

     const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        ok: false,
        data : null,
        error: data?.message || "Unknown error"
      };
    }

    return {
      ok: true,
      data
    };
  } catch (e) {
    return {
      ok: false,
      error: e ||  "Network error"
    };
  }
}

export async function submitMcosPrescriptionResponse(payload) {
	try {
		const response = await fetch(`${process.env.CRM_URL}provider-notifications/mcos-order-answer`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		});

		// parse JSON first (you already do this)
		const data = await response?.json?.().catch(() => null);

		// if the server returned an error status, throw an Error with the API message if present
		if (!response.ok) {
			const errMsg = data?.message || `HTTP error! status: ${response.status}`;
			const err = new Error(errMsg);
			// attach extra info for callers if they want to inspect it
			err.status = response.status;
			err.data = data;
			throw err;
		}

		if (!data?.success) {
			throw new Error(data?.message || 'Request failed');
		}

		return data?.data || {};
	} catch (e) {
		console.error('Error submitting MCOS prescription response:', e);
		throw e;
	}
}

export async function submitReturnedToPharmacyWebhook(payload) {
	try {
		const response = await fetch(`${process.env.CRM_URL}provider-notifications/returned-to-pharmacy`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		});

		const data = await response?.json?.().catch(() => null);

		if (!response.ok) {
			const errMsg = data?.message || `HTTP error! status: ${response.status}`;
			const err = new Error(errMsg);
			err.status = response.status;
			err.data = data;
			throw err;
		}

		if (!data?.success) {
			throw new Error(data?.message || 'Request failed');
		}

		return data?.data || {};
	} catch (e) {
		console.error('Error submitting returned-to-pharmacy webhook:', e);
		throw e;
	}
}

export async function submitCommonApiOrderResponse(payload) {
	try {
		const documentNumber = payload?.document_number
			?? payload?.documentNumber
			?? payload?.prescriptionId
			?? null;

		const {
			prescriptionId: _legacyPrescriptionId,
			documentNumber: _camelDocumentNumber,
			...restPayload
		} = payload || {};

		const normalizedPayload = {
			...restPayload,
			document_number: documentNumber,
		};

		const response = await fetch(`${process.env.CRM_URL}provider-notifications/common-order-answer`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(normalizedPayload)
		});

		const data = await response?.json?.().catch(() => null);

		if (!response.ok) {
			const errMsg = data?.message || `HTTP error! status: ${response.status}`;
			const err = new Error(errMsg);
			err.status = response.status;
			err.data = data;
			throw err;
		}

		if (!data?.success) {
			throw new Error(data?.message || 'Request failed');
		}

		return data?.data || {};
	} catch (e) {
		console.error('Error submitting Common API order response:', e);
		throw e;
	}
}

export async function getUrbifyCoverageAPI(postcode, token = localStorage.getItem("crm_auth_token"), isNextDay = false) {
  try {
    const queryString = new URLSearchParams({ serviceType: isNextDay ? 'urbify_next_day' : 'urbify' }).toString();
    const response = await getCRM(`urbify/coverage/${postcode}?${queryString}`, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Urbify API Fehler');
  }
}

export async function getCardFloPayments(dateFrom, dateTo, token = localStorage.getItem("crm_auth_token")) {
  try {
    const queryString = new URLSearchParams({ startDate: dateFrom, endDate: dateTo }).toString();
    return await getCRM(`reports-generation/get-cardflo-payments?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { total: 0 } };
  }
}

export async function getNegativeVirtualAmountOrders(isReserved, token = localStorage.getItem("crm_auth_token")) {
  try {
    const queryString = new URLSearchParams({
      isReserved: String(Boolean(isReserved))
    }).toString();
    return await getCRM(`reports-generation/negative-virtual-amount-orders?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { totalNegativeVirtualAmountProducts: 0 } };
  }
}

export async function getNegativeVirtualAmountOrderDetails(
  inventoryId,
  { sort, order, isReserved } = {},
  token = localStorage.getItem("crm_auth_token")
) {
  try {
    const orderDir = String(order || 'asc').toLowerCase() === 'desc' ? 'desc' : 'asc';
    const queryString = new URLSearchParams({
      inventoryId: String(inventoryId),
      sort: String(sort ?? ''),
      order: orderDir,
      isReserved: String(Boolean(isReserved))
    }).toString();
    return await getCRM(`reports-generation/negative-virtual-amount-order-details?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { total: 0 } };
  }
}

export async function getShopProductUnits(token = localStorage.getItem('greeners_auth_token')) {
  try {
    const result = await getGreeners('product/units', token);
    const choices = result?.data;
    if (!Array.isArray(choices) || !choices.length) {
      return [
        { label: 'Stück', value: 'stuck' },
        { label: 'g', value: 'g' },
        { label: 'ml', value: 'ml' }
      ];
    }
    return choices
      .map((choice) => {
        if (typeof choice === 'string') {
          return { label: choice, value: choice };
        }
        const value = choice?.value ?? choice?.text;
        if (value == null || value === '') return null;
        return {
          label: choice?.text ?? String(value),
          value: String(value)
        };
      })
      .filter(Boolean);
  } catch (e) {
    console.log(e);
    return [
      { label: 'Stück', value: 'stuck' },
      { label: 'g', value: 'g' },
      { label: 'ml', value: 'ml' }
    ];
  }
}

export async function createProductForShop(formData, token) {
    try {
        return await postGreeners(`product`, token, formData, true);
    }
    catch (e) {
        console.log(e);
        return [];
    }
}

export async function updateProductForShop(productId, formData, token = localStorage.getItem('greeners_auth_token')) {
    try {
        return await putGreeners(`product/${productId}`, token, formData, true);
    } catch (e) {
        console.log(e);
        throw e;
    }
}

export async function getShopProducts(query, token = localStorage.getItem('greeners_auth_token')) {
    const args = {
        limit: query.limit,
        offset: query.offset || 0,
        filter: query.filter ? JSON.stringify(query.filter) : JSON.stringify({}),
        search: query.search,
        sort: query.sort,
    };
    let queryString = new URLSearchParams(args).toString();
    return await getGreeners(`product?${queryString}`, token);
}

export async function getSingleProductShopImages(productId, token = localStorage.getItem('greeners_auth_token')) {
    return await getGreeners(`product/${productId}/images`, token);
}

export async function createProductInventoryShopProduct(data, token = localStorage.getItem('greeners_auth_token')) {
    try {
        return await postGreeners(`product/inventory`, token, data);
    } catch (e) {
        console.log(e);
        throw e;
    }
}

/**
 * Pharmacy-scoped PZN uniqueness check (blur validation on inventory submit).
 * @returns {{ success: boolean, available: boolean, exists: boolean, reason?: string }}
 */
export async function checkPharmacyInventoryPzn(
    pzn,
    { excludeId } = {},
    token = localStorage.getItem('greeners_auth_token')
) {
    const params = new URLSearchParams({ pzn: String(pzn || '').trim() });
    if (excludeId) {
        params.set('exclude_id', String(excludeId));
    }
    return await getGreeners(`product/inventory/check-pzn?${params.toString()}`, token);
}

function buildPharmacyKpiQuery({ mainPharmacy, dateFrom, dateTo, groupBy, statuses, limit }) {
  const params = new URLSearchParams({
    main_pharmacy: mainPharmacy,
    date_from: dateFrom,
    date_to: dateTo,
  });

  if (groupBy) {
    params.set('group_by', groupBy);
  }

  if (limit != null) {
    params.set('limit', String(limit));
  }

  if (statuses?.length) {
    params.set('statuses', statuses.join(','));
  }

  return params.toString();
}

export async function getPharmacyKpiOrdersSummary(
  { mainPharmacy, dateFrom, dateTo, groupBy, statuses },
  token = localStorage.getItem('crm_auth_token'),
  signal = null,
) {
  const queryString = buildPharmacyKpiQuery({ mainPharmacy, dateFrom, dateTo, groupBy, statuses });
  return await getCRM(`pharmacy-kpi/orders-summary?${queryString}`, token, signal);
}

export async function getPharmacyKpiProductsSummary(
  { mainPharmacy, dateFrom, dateTo, limit, statuses },
  token = localStorage.getItem('crm_auth_token'),
  signal = null,
) {
  const queryString = buildPharmacyKpiQuery({ mainPharmacy, dateFrom, dateTo, statuses, limit });
  return await getCRM(`pharmacy-kpi/products-summary?${queryString}`, token, signal);
}

export async function getPharmacyKpiGrossProfit(
        { mainPharmacy, dateFrom, dateTo, statuses },
        token = localStorage.getItem('crm_auth_token'),
        signal = null,
) {
        const queryString = buildPharmacyKpiQuery({ mainPharmacy, dateFrom, dateTo, statuses });
        return await getCRM(`pharmacy-kpi/gross-profit?${queryString}`, token, signal);
}
// ── Background CSV export endpoints ────────────────────────────────────────────────────
export async function startOrderExport({ filter, sort, keys, isDraftOrderList, format }, token = localStorage.getItem('crm_auth_token')) {
  const res = await fetch(`${process.env.CRM_URL}order/orderlist/export-orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ filter, sort, keys, isDraftOrderList, format, crmUrl: `${window.location.origin}/` }),
  });
  return res.json();
}

export async function getOrderExportStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
  return getCRM(`order/orderlist/export-orders/status/${taskId}`, token);
}

export async function getOrderExportData(taskId, token = localStorage.getItem('crm_auth_token')) {
  return getCRM(`order/orderlist/export-orders/data/${taskId}`, token);
}

export async function deleteExportFile(fileId, token = localStorage.getItem('crm_auth_token')) {
  return deleteCRM(`order/orderlist/export-orders/file/${fileId}`, token);
}

export async function cancelOrderExport(taskId, token = localStorage.getItem('crm_auth_token')) {
  return postCRM(`order/orderlist/export-orders/cancel/${taskId}`, token, {});
}

// ── Cansativa wholesaler ordering ──────────────────────────────────────────────────────
// Places an order with Cansativa. `items` are [{ pzn, quantity }] — the PZN comes off the
// same inventory object that drives the GH marker. The backend resolves the API key and
// BtM number from the pharmacy's tokens row and generates the idempotency key.
//
// Resolves to { success, message, orders, idempotent, idempotency_key } on success AND on
// failure, so the caller can notify off `message` either way.
export async function createCansativaOrder({ pharmacyId, pharmacyTitle, items, notes, mwstPercent, shippingCharges }, token = localStorage.getItem('crm_auth_token')) {
  const greenersToken = localStorage.getItem('greeners_auth_token');
  return postCRM('order/cansativa/orders', token, { pharmacyId, pharmacyTitle, items, notes, mwstPercent, shippingCharges, greenersToken });
}

// This pharmacy's B2B order history, newest first. Every user of the pharmacy sees all
// of its orders, so the pharmacy id is the only scope.
export async function getCansativaOrders(
  { pharmacyId, limit = 50, page = 1, search = '' },
  token = localStorage.getItem('crm_auth_token')
) {
  const args = new URLSearchParams({ pharmacyId, limit, page });
  // Search matches a PZN, a product name or a cultivar on any position of the order.
  if (search) args.set('search', search);
  return getCRM(`order/cansativa/orders?${args.toString()}`, token);
}

// A single B2B order with its positions, by id.
export async function getCansativaOrder(orderId, token = localStorage.getItem('crm_auth_token')) {
  return getCRM(`order/cansativa/orders/${orderId}`, token);
}

// Cansativa's tier price for a cart. `unit_price` and `total_price` come back as
// CENTS PER PACKAGE (4490 = 44,90 EUR). Display only — the order endpoint sends no prices.
export async function getCansativaPricing({ pharmacyId, items }, token = localStorage.getItem('crm_auth_token')) {
  return postCRM('order/cansativa/pricing', token, { pharmacyId, items });
}

// MHD of the current Cansativa batch per PZN. Returns { success, mhd: { pzn: 'YYYY-MM-DD'|null } }.
// A PZN without a current batch comes back as null — that is not an error.
export async function getCansativaProductMhd({ pharmacyId, pzns }, token = localStorage.getItem('crm_auth_token')) {
  return postCRM('order/cansativa/products/mhd', token, { pharmacyId, pzns });
}

// ── Bestelldaten report (queued, cached per filter for an hour) ────────────────
// The job always builds the CSV; XLSX and PDF are derived from it on download
export async function startBestelldatenReport({ filter, sort, sourceLabels, summary }, token = localStorage.getItem('crm_auth_token')) {
  const res = await fetch(`${process.env.CRM_URL}order/orderlist/export-bestelldaten`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ filter, sort, sourceLabels, summary }),
  });
  return res.json();
}

export async function getBestelldatenStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
  return getCRM(`order/orderlist/export-bestelldaten/status/${taskId}`, token);
}

// XLSX / PDF are rendered from the same rows the CSV was built from
export async function getBestelldatenFile(cacheKey, format = 'csv', token = localStorage.getItem('crm_auth_token')) {
  return getCRM(`order/orderlist/export-bestelldaten/file/${cacheKey}?format=${format}`, token);
}
